import type { ReactNode } from 'react'
import { useDocumentTitle } from '../lib/title'

/** Wat er achter een paginanaam komt, en wat er staat als er geen naam is. */
const brand = 'Confetti'

/**
 * De titel van een scherm aan onze kant: "QR-code - Confetti".
 *
 * Als omhulsel om een route, zodat alle titels bij elkaar in App.tsx staan naast
 * het pad waar ze bij horen, in plaats van verspreid over zeventien componenten
 * die er verder niets mee te maken hebben. Vergeet je er een, dan zie je dat
 * daar meteen.
 *
 * Dit is bewust niet wat het gastenportaal gebruikt. Daar staat de naam van het
 * feest in het tabblad en verder niets: dat scherm is van het bruidspaar, en
 * onze merknaam in de tab van hun gasten is reclame op iemand anders zijn feest.
 */
export function Titled({ title, children }: { title: string | null; children: ReactNode }) {
  useDocumentTitle(title ? `${title} - ${brand}` : brand)

  return children
}
